export var PLATFORM_TABLES;
(function (PLATFORM_TABLES) {
  PLATFORM_TABLES["ROLE_PERMISSIONS"] = "role-permissions";
  PLATFORM_TABLES["PLATFORM_USERS"] = "platform-user";
})(PLATFORM_TABLES || (PLATFORM_TABLES = {}));